var map = {
	"./404.vue": 283,
	"./components/face.vue": 284,
	"./delivery/book.vue": 1214,
	"./delivery/config.vue": 1215,
	"./delivery/deliveryList.vue": 421,
	"./delivery/dispatchList.vue": 422,
	"./delivery/fastIn.vue": 423,
	"./delivery/list.vue": 424,
	"./delivery/newCustomer.vue": 425,
	"./delivery/order.vue": 426,
	"./delivery/orderList.vue": 427,
	"./demo.vue": 428,
	"./distribution/fastInStorage.vue": 429,
	"./distribution/list.vue": 430,
	"./distribution/order.vue": 431,
	"./distribution/outStorage.vue": 432,
	"./face.vue": 433,
	"./freightage/houserAddress.vue": 434,
	"./freightage/priceContort.vue": 435,
	"./freightage/priceGoods.vue": 436,
	"./login.vue": 437,
	"./order/addOrder.vue": 438,
	"./order/boxOrderList.vue": 439,
	"./order/checkExpress.vue": 440,
	"./order/dispatchList.vue": 441,
	"./order/orderList.vue": 442,
	"./personnel/addEditComponent.vue": 443,
	"./personnel/adminList.vue": 444,
	"./personnel/announcement.vue": 445,
	"./personnel/customerList.vue": 446,
	"./recharge/account.vue": 447,
	"./recharge/adjust.vue": 448,
	"./recharge/charge.vue": 449,
	"./recharge/flows.vue": 450,
	"./recharge/rate.vue": 451,
	"./repertory/goOutList.vue": 452,
	"./repertory/repertoryList.vue": 453,
	"./statistical/cost.vue": 454,
	"./statistical/runningWater.vue": 1216,
	"./statistical/wayBill.vue": 455,
	"./system/agree.vue": 456,
	"./system/notice.vue": 457,
	"./transport/list.vue": 458,
	"./workOrder/workOrderList.vue": 459,
	"./workOrder/workOrderRemark.vue": 460
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1312;


//////////////////
// WEBPACK FOOTER
// ./src/page ^\.\/.*\.vue$
// module id = 1312
// module chunks = 2